import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { fetchUserDetailsByMobileData } from "../../../redux/reducers/apiSlice";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import UserInfo from "../../Open-pages/user/UserInfo";

const ValidateByMobile = (props) => {
  const dispatch = useDispatch();
  const { loading, userDetailsByMobile } = useSelector((state) => state.api);

  const {
    mobileNumber,
    iniFormValues,
    formValues,
    setFormValues,
    formErrors,
    memberStatus,
    setMemberStatus,
    onChangeInput,
    setCurrentTaskIndex,
    memberFetchedData,
    setMemberFetchedData,
    iniMemStatus,
    isFetchUser,
    setIsFetchUser,
    token,
  } = props;

  function onClickFetchUserDetails(e) {
    e.preventDefault();

    if (formValues.mobileNumber && !formErrors.mobileNumber) {
      setIsFetchUser(true);
      getMemberDetails();
    }
  }

  function onClearNumber(e) {
    e && e.preventDefault();

    const handleConfirm = () => {
      setFormValues(iniFormValues);
      setIsFetchUser(false);
      setMemberFetchedData(null);
      setCurrentTaskIndex(0);
      localStorage.removeItem("hygiene_form_mobile_number");
    };

    showConfirmAlert(handleConfirm, `You want to clear the form?`);
  }

  function getMemberDetails() {
    dispatch(
      fetchUserDetailsByMobileData({
        userMobile: formValues.mobileNumber,
        token: token,
        qps: "&is_token=1",
      })
    );
  }

  useEffect(() => {
    if (mobileNumber && !memberFetchedData) {
      setIsFetchUser(true);
      getMemberDetails();
    }
  }, []);

  useEffect(() => {
    if (
      isFetchUser &&
      !loading &&
      !formErrors.mobileNumber &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      const memberData = userDetailsByMobile.data[0];
      setMemberFetchedData(memberData);

      localStorage.setItem(
        "hygiene_form_mobile_number",
        JSON.stringify({
          mobileNumber: formValues.mobileNumber,
          date: FORMATTED_TODAY_DATE_YYYYMMDD,
          userInfoData: memberData,
        })
      );
    } else if (
      isFetchUser &&
      !loading &&
      !formErrors.mobileNumber &&
      !userDetailsByMobile?.status
    ) {
      userDetailsByMobile?.message && toast.error(userDetailsByMobile?.message);
      setMemberFetchedData(null);
      setIsFetchUser(false);
      return;
    } else {
      setMemberFetchedData(null);
      return;
    }
  }, [isFetchUser, loading, userDetailsByMobile, formErrors.mobileNumber]);

  useEffect(() => {
    if (memberFetchedData && !loading) {
      const userAcountType = memberFetchedData?.account_type || "";

      if (userAcountType !== "member") {
        setMemberStatus((prevs) => ({
          ...prevs,
          isShowForm: true,
          errorMessage: "",
          isShowTasksForm: false,
        }));
      } else {
        setMemberStatus((prevs) => ({
          ...prevs,
          isShowForm: false,
          errorMessage: "Member Can Not Use This Form!",
          isShowTasksForm: false,
        }));
      }
    } else {
      setMemberStatus(iniMemStatus);
    }
  }, [memberFetchedData, loading]);

  return (
    <>
      <div className="formInputsGrid twoGridSystem input-with-btn">
        <div className="formInputBox gap0">
          <input
            type="number"
            placeholder="Enter Your Mobile Number"
            className={`formInput ${
              formErrors?.mobileNumber ? "formError" : ""
            }`}
            name="mobileNumber"
            value={formValues.mobileNumber}
            onChange={onChangeInput}
          />

          {formErrors?.mobileNumber && (
            <span className="error-label">{formErrors.mobileNumber || ""}</span>
          )}

          {!memberStatus.isShowForm && memberStatus.errorMessage && (
            <span className="info">{memberStatus.errorMessage || ""}</span>
          )}
        </div>

        <div className="formInputButtons" style={{ marginTop: "0" }}>
          <Button
            type="button"
            className="saveBtn"
            variant="danger"
            onClick={onClickFetchUserDetails}
            disabled={memberFetchedData || formErrors.mobileNumber}>
            {loading ? <Loader /> : "Fetch Details"}
          </Button>
          {!loading && (
            <Button
              type="button"
              variant="outline-dark"
              className="cancelBtn"
              onClick={onClearNumber}>
              Clear
            </Button>
          )}
        </div>
      </div>

      {memberStatus.isShowForm ? (
        <>
          <UserInfo userData={memberFetchedData} />

          <div className="form-btn-indipendant mt-0">
            <Button
              type="button"
              className="normal-semi-color-btn"
              variant="danger"
              onClick={() =>
                setMemberStatus((prevs) => ({
                  ...prevs,
                  isShowTasksForm: true,
                }))
              }>
              continue
            </Button>
          </div>
        </>
      ) : null}
    </>
  );
};

export default ValidateByMobile;
